<template>
    <div id="guide">
        <Header :title="title" />

        <div v-if="app.template.type === '92fanli'">
            <main class="MainCon bottom0 bg_white">
                <div class="myimg" v-show="app.template.style === 'main'"><img
                        src="@/assets/images/guide_green.jpg" /></div>
                <div class="myimg" v-show="app.template.style === 'main_b'"><img
                        src="@/assets/images/guide_red.jpg" /></div>
                <div class="myimg" v-show="app.template.style === 'main_c'"><img
                        src="@/assets/images/guide_yellow.jpg" /></div>
            </main>
        </div>
        <div v-else-if="app.template.type === 'damai'">
            <main class="MainCon bottom0 bg_white">
                <div class="myimg" v-show="app.template.style === 'main'"><img
                        src="@/assets/images/guide_red.jpg" /></div>
                <div class="myimg" v-show="app.template.style === 'main_b'"><img
                        src="@/assets/images/guide_yellow.jpg" /></div>
                <div class="myimg" v-show="app.template.style === 'main_c'"><img
                        src="@/assets/images/guide_green.jpg" /></div>
            </main>
        </div>
        <div v-else>
            <main class="MainCon bottom0 bg_white">
                <div class="myimg" v-show="app.template.style === 'main'"><img
                        src="@/assets/images/guide_yellow.jpg" /></div>
                <div class="myimg" v-show="app.template.style === 'main_b'"><img
                        src="@/assets/images/guide_red.jpg" /></div>
                <div class="myimg" v-show="app.template.style === 'main_c'"><img
                        src="@/assets/images/guide_green.jpg" /></div>
            </main>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Header from '../components/Header';
    import {isMobile} from '../libs/utils';

    export default {
        components: {Header},
        data() {
            return {
                title: '新手指南'
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin;
            }
        }
    }
</script>

<style scoped>

</style>
